import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-localize-redux';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import PropTypes from 'prop-types';

import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

const CHECK_SYMBOL = "✓";

class VehicleRow extends React.Component {
    state = {
        expanded: false
    };

    static propTypes = {
        data: PropTypes.object.isRequired,
        ownershipData: PropTypes.object.isRequired
    };

    render() {
        const data = this.props.data;
        return (
            <>
                <tr key={data.rowId}>
                    <td>
                        <span onClick={() => this.expandRow()} className="link-internal">
                            <Translate id='Report.Detail' />
                        </span>
                    </td>
                    <td>{data.category}</td>
                    <td>{this.getStatus(data.status)}</td>
                    <td className="has-text-right">{data.dateFirstRegistrationFormatted}</td>
                    <td className="has-text-right">{data.dateFirstRegistrationCSFormatted}</td>
                    <td>{this.getLeasing(data.leasing)}</td>
                    <td className="has-text-centered">{CHECK_SYMBOL}</td>
                    <td className="has-text-centered">
                        {data.operator === data.owner ? CHECK_SYMBOL :
                            `${isNullOrUndefined(data.ownerFullName) ? "" : data.ownerFullName}${isNullOrUndefined(data.ownerCompanyId) ? "" : ` (${data.ownerCompanyId})`}`}
                    </td>
                    <td>{data.colorMain}</td>
                    <td style={{ wordWrap: "break-word" }}>{data.brand}</td>
                </tr>
                {this.state.expanded && this.renderDetail(data)}
            </>
        )
    }

    renderDetail = (data) => {
        return (
            <tr key={`${data.rowId}-detail`}>
                <td colSpan={10} style={{ padding: '1em 2em' }}>
                    <OldStyleTableWithHistory
                        colWidths={["25%", "25%", "25%", "25%"]} noMargin
                        actualData={[1, 2, 3, 4]} fixed classNames='old-style-bordered'
                        actualRow={p => <>{p === 1 && <tr>
                            <th><Translate id="Report.ListOfVehicles.VIN" /></th>
                            <td style={{ fontWeight: 'normal' }}>{data.vin}</td>
                            <th><Translate id="Report.ListOfVehicles.TradeName" /></th>
                            <td style={{ fontWeight: 'normal' }}>{data.trade}</td>
                        </tr>}{p === 2 && <tr>
                            <th><Translate id="Report.ListOfVehicles.DistrictRegistration" /></th>
                            <td style={{ fontWeight: 'normal' }}>{data.registrationCountry}</td>
                            <th><Translate id="Report.ListOfVehicles.Mass" /></th>
                            <td className="has-text-right" style={{ fontWeight: 'normal' }}>{data.weigthKg}&nbsp;kg</td>
                        </tr>}{p === 3 && <tr>
                            <th><Translate id="Report.ListOfVehicles.RegistrationPoint" /></th>
                            <td style={{ fontWeight: 'normal' }}>{data.registrationPlace}</td>
                            <th><Translate id="Report.ListOfVehicles.ComplementaryColor" /></th>
                            <td style={{ fontWeight: 'normal' }}>{data.colorSecondary}</td>
                        </tr>}{p === 4 && !isNullOrUndefined(data.deregistrationDate) && <tr>
                            <th><Translate id="Report.ListOfVehicles.DateDe-Registration" /></th>
                            <td className="has-text-right" style={{ fontWeight: 'normal' }}>{data.deregistrationDateFormatted}</td>
                            <th><Translate id="Report.ListOfVehicles.MethodOfExclusionRegister" /></th>
                            {data.deregistrationMethod === "Z" && <td style={{ fontWeight: 'normal' }}>{<Translate id="Report.ListOfVehicles.PermanentlyCheckedOut" />}</td>}
                            {data.deregistrationMethod === "E" && <td style={{ fontWeight: 'normal' }}>{<Translate id="Report.ListOfVehicles.CheckedOutAbroad" />}</td>}
                            {data.deregistrationMethod !== "E" && data.deregistrationMethod !== "Z" && <td style={{ fontWeight: 'normal' }}>{data.deregistrationMethod}</td>}
                        </tr>}</>}
                    />
                </td>
            </tr>
        )
    }

    expandRow = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    getStatus = (status) => {
        var transKey = ""
        switch (status) {
            case "N": transKey = "New"; break;
            case "O": transKey = "Old"; break;
            default: transKey = ""; break;
        }
        return transKey === "" ? "" : <Translate id={`Report.RegisteredVehicles.ByStatus.${transKey}`} />
    }

    getLeasing = (leasing) => {
        var transKey = ""
        switch (leasing) {
            case "A": transKey = "Yes"; break;
            case "N": transKey = "No"; break;
            default: transKey = ""; break;
        }
        return transKey === "" ? "" : <Translate id={`Common.${transKey}.Upper`} />
    }
}

export default connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(VehicleRow);